function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-5 4v-2h-1v2H8v-2H7v2a1 1 0 001 1h8a1 1 0 001-1zm-2.854-5.354L12.5 12.293V7h-1v5.293l-1.646-1.647-.708.708L12 14.207l2.854-2.853-.707-.708z",
  fill: "#55AB3A"
});

function SvgShareSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default "/app/dist/assets/share-save.svg";
export { SvgShareSave as ReactComponent };